import { useContext } from 'react';
import { AxiosContext } from './AxiosContext';
import { AxiosContextProps } from './AxiosInterface';

export const useAxios = (): AxiosContextProps => {
  const context = useContext<AxiosContextProps | undefined>(AxiosContext);

  if (!context) {
    throw new Error(
      'AxiosProvider context is undefined, useAxios needs to be child to <AxiosProvider>.'
    );
  }

  return context;
};
